module.exports = __webpack_public_path__ + "static/media/step3.1eb3e82c.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/Home/photos/step3.mp4
// module id = 242
// module chunks = 8